import { Expose, Type } from 'class-transformer'
import { Package } from 'react-feather'

import { UnitOfMeasure } from './SkuBase'
import { Product } from './Product'

export class AuditResultSku {
  static type = 'auditresultsku'
  static typeDisplay = 'Audit Result SKU'
  static icon = Package

  type = AuditResultSku.type
  typeDisplay = AuditResultSku.typeDisplay
  icon = AuditResultSku.icon

  @Expose({ name: 'xid' })
  guid?: string

  sku?: string

  @Type(() => Product)
  product: Product = new Product()

  @Expose({ name: 'num_available' })
  numAvailable?: number

  @Expose({ name: 'num_reserved' })
  numReserved?: number

  @Expose({ name: 'num_awaiting_shipment' })
  numAwaitingShipment?: number

  @Expose({ name: 'num_damaged' })
  numDamaged?: number

  @Expose({ name: 'num_units_in_audit' })
  numUnitsInAudit?: number

  @Expose({ name: 'unit_of_measure' })
  unitOfMeasure: UnitOfMeasure = UnitOfMeasure.eaches

  static unitOfMeasureMap = {
    [UnitOfMeasure.cases]: 'case(s)',
    [UnitOfMeasure.eaches]: 'each(es)',
    [UnitOfMeasure.lbs]: 'lb(s)',
  }

  get unitOfMeasureDisplay() {
    return AuditResultSku.unitOfMeasureMap[this.unitOfMeasure]
  }
}
